import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-welcome-video-dialog',
  template: `
    <iframe class="w-full aspect-video block"
      src="https://player.vimeo.com/video/1241262041?h=e7382873ce&badge=0&autopause=0&autoplay=1&title=0&byline=0&portrait=0"
      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      title="Credit Union Portal Intro"></iframe>
  `
})
export class WelcomeVideoDialogComponent {}
